export const KEYWORDS = 'keywords';
export const CATEGORIES = 'categories';
export const ICDCODES = 'icdCodes';
export const CTCAE_CATEGORIES = 'ctcaeCategories';
